
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title:
      "Astuces pour réduire le CPC sur Google Ads sans sacrifier la qualité",
    description:
      "Découvrez comment réduire votre CPC sur Google Ads tout en maintenant la qualité de vos annonces grâce aux conseils d’ALEO pour optimiser vos enchères efficacement.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
